import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../foundations/colors.module.scss';
import shadows from '../../foundations/shadows.module.scss';
import typography from '../../foundations/typography.module.scss';
import { baseMenuPaperStyles, baseMenuItemStyles } from '../Menu/Menu.styles';
export const useDropdownMenuStyles = makeStyles({
    menu: function menu() {
        let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, baseMenuPaperStyles), {
            // DropdownMenu-specific overrides
            fontFamily: typography.fontFamilyLight,
            fontSize: typography.fontSizeP1,
            background: colors.dark50,
            // Override baseMenuPaperStyles boxShadow with DropdownMenu-specific shadow
            boxShadow: shadows.sh60,
            color: colors.dark700
        }), props), {
            // Apply base menu item styles to all menu items in this menu
            '& .MuiMenuItem-root': baseMenuItemStyles
        });
    },
    promotionalAction: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 20px',
        marginBottom: '-8px',
        background: colors.dark70,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
        '&:hover': {
            background: colors.dark100
        }
    }
});
